import React, { useState } from 'react';
import axios from 'axios';
import {
  UPDATE_LOCATION_URL,
  PATIENT_MANAGER_BASE_URL,
  authResponse
} from '../../constants';

const SyncAthena = () => {
  const [syncMessage, setSyncMessage] = useState('');
  const [isSyncing, setIsSyncing] = useState(false);



  const handleAthenaSync = async () => {
    setIsSyncing(true);
    setSyncMessage('');
    try {
      // Fetch token from Microsoft
      const tokenReq = await authResponse();
      const token = tokenReq.data.access_token;

      // Make request using the token
      const headers = {
        sourceFrom: "cmdFrontend",
        transactionID: new Date().getTime(),
        clientID: "cmdFrontend",
        requestedDateTime: new Date().toISOString(),
        accept: "application/json",
        Authorization: `Bearer ${token}`
      };

      const response = await axios.post(
        `${PATIENT_MANAGER_BASE_URL}${UPDATE_LOCATION_URL}`,
        null,
        { headers }
      );
      if (response?.status === 200) {
        setSyncMessage("Successfully Synced With Athena, Please Update the Bio for the new providers");
      } else {
        setSyncMessage("Sync failed. Please try again.");
      }
    } catch (error) {
      setSyncMessage("Error occurred during sync.");
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <main data-testid='SyncAthenaElement' style={{ padding: '100px 40px 40px', minHeight: '80vh' }}>
      <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center', backgroundColor: 'white', padding: '40px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <h2 style={{ color: '#264E5A', marginBottom: '20px', fontFamily: 'Macklin Sans' }}>Sync With Athena</h2>
        <p style={{ color: '#666', marginBottom: '30px', fontSize: '16px' }}>
          Click the button below to synchronize location and provider mappings from Athena.
        </p>
        <button
          onClick={handleAthenaSync}
          disabled={isSyncing}
          style={{
            padding: '12px 24px',
            backgroundColor: '#FEB52B',
            color: '#264E5A',
            border: 'none',
            borderRadius: '4px',
            cursor: isSyncing ? 'not-allowed' : 'pointer',
            fontWeight: 'bold',
            fontSize: '18px'
          }}
        >
          {isSyncing ? 'Syncing...' : 'Sync'}
        </button>
        {syncMessage && (
          <div style={{
            marginTop: '25px',
            padding: '15px',
            backgroundColor: syncMessage.includes('Successfully') ? '#e8f5e9' : '#ffebee',
            color: syncMessage.includes('Successfully') ? '#2e7d32' : '#c62828',
            borderRadius: '4px',
            border: `1px solid ${syncMessage.includes('Successfully') ? '#a5d6a7' : '#ef9a9a'}`,
            fontSize: '15px'
          }}>
            {syncMessage}
          </div>
        )}
      </div>
    </main>
  );
};

export default SyncAthena;
